import EditController from "./forms/EditController";
import Edit from "./forms/Edit.vue";
import List from "./forms/List.vue";
import ListController from "./forms/ListController";

export default {
  description: "Акты списания медикаментов и перевязочных средств",
  forms: {
    edit: {
      component: Edit,
      controller: EditController,
      panel: {
        width: "92%",
        modal: false,
      },
    },
    list: {
      component: List,
      controller: ListController,
      config: {
        fields: {
          id: {
            config: { visible: false, hide: true },
          },
          act_number: {
            description: "Номер",
            config: {
              width: "120px",
              sticky: true,
              sorting: '"medicament_writeoff_acts"."act_number"',
            },
          },
          act_date: {
            description: "Дата",
            config: {
              width: "120px",
              sorting: '"medicament_writeoff_acts"."act_date"',
            },
          },
          warehouse_id: {
            description: "Склад",
            config: {
              width: "220px",
              reference: "consignees",
              displayField: "name",
              sorting: '"warehouse_id"."name"',
            },
          },
          department_id: {
            description: "Подразделение",
            config: {
              width: "220px",
              reference: "consignees",
              displayField: "name",
              sorting: '"department_id"."name"',
            },
          },
          responsible_fio: {
            description: "ФИО МОЛ",
            config: {
              width: "200px",
              sorting: '"medicament_writeoff_acts"."responsible_fio"',
            },
          },
          status: {
            description: "Статус",
            config: {
              width: "120px",
              sorting: '"medicament_writeoff_acts"."status"',
              display: (v: string) => {
                if (v === "posted") return "Проведён";
                return "Черновик";
              },
            },
          },
          created_at: {
            description: "Создано",
            config: { visible: false, hide: true },
          },
          updated_at: {
            description: "Изменено",
            config: { visible: false, hide: true },
          },
          deletionmark: {
            config: { visible: false, hide: true },
          },
        },
      },
    },
  },
  columns: [
    { field: "act_number", description: "Номер", width: 120, sticky: true },
    { field: "act_date", description: "Дата", width: 120 },
    {
      field: "warehouse_id",
      description: "Склад",
      width: 220,
      render: (row: any) => row._warehouse_id || "",
    },
    {
      field: "department_id",
      description: "Подразделение",
      width: 220,
      render: (row: any) => row._department_id || "",
    },
    {
      field: "responsible_fio",
      description: "ФИО (списано)",
      width: 200,
      render: (row: any) => row.responsible_fio || "",
    },
    {
      field: "status",
      description: "Статус",
      width: 120,
      render: (row: any) => (row.status === "posted" ? "Проведён" : "Черновик"),
    },
  ],
};
